import { Card, Fieldset, Heading, Paragraph, ResponsiveImage } from "@vwfs-bronson/bronson-react"
import { useTranslation } from "react-i18next"
import { openTabUrl } from "../../../../../services/common/utils"

export const WarrantyLegalComponent = () => {
  const { t } = useTranslation()
  return (
    <Card title="" className="u-text-left">
      <Fieldset.Row>
        <Heading level={2}>
          {t('form:dataProtection:warrantyLabel:title')}
        </Heading>
        <Paragraph>{t('form:dataProtection:warrantyLabel:text')}</Paragraph>
        <ResponsiveImage
          src={`${process.env.PUBLIC_URL}/assets/images/Legal-guarantee-harmonised-notice_de.jpg`}
          height="250vh"
          onClick={() => {
            openTabUrl(`${process.env.PUBLIC_URL}/assets/images/Legal-guarantee-harmonised-notice_de.jpg`)
          }}
          style={{ cursor: "pointer" }}
        />
      </Fieldset.Row>
    </Card>
  )
}